import React from 'react';

interface NotificationViewProps {
  notifications: string[];
}

export const NotificationView: React.FC<NotificationViewProps> = ({ notifications }) => {
  if (notifications.length === 0) return null;

  return (
    <div style={{
      position: 'fixed',
      top: '60px',
      left: 0,
      right: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '10px',
      pointerEvents: 'none',
      zIndex: 100
    }}>
      {notifications.map((notification, index) => (
        <div
          key={index}
          className="slide-in-top"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.25), rgba(255, 255, 255, 0.15))',
            border: '1.5px solid rgba(255, 255, 255, 0.4)',
            borderRadius: '50px',
            padding: '12px 20px',
            boxShadow: '0 5px 10px rgba(0, 0, 0, 0.2)'
          }}
        >
          <span style={{ fontSize: '14px' }}>🔔</span>
          <span style={{
            fontSize: '14px',
            fontWeight: '600',
            color: 'white'
          }}>
            {notification}
          </span>
        </div>
      ))}
    </div>
  );
};
